import { render, staticRenderFns } from "./editFreeze.vue?vue&type=template&id=df1ea830&"
import script from "./editFreeze.vue?vue&type=script&lang=js&"
export * from "./editFreeze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports